import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { creatorsVerificationSaga } from "./saga";

export const initialState = {
  creatorsInstagramInfo: {
    loading: false,
    error: null,
    creatorsLogs: [],
    pagination: {},
    statusMeta: {}
  },
  verifyInfo: {
    loading: false,
    error: null,
    creatorUserId: null,
    success: ""
  }
};

export const CreatorsVerificationSlice = createSlice({
  name: "creatorsVerification",
  initialState,
  reducers: {
    fetchCreatorsInstagramRequest(state, action) {
      state.creatorsInstagramInfo.loading = true;
      state.creatorsInstagramInfo.error = null;
    },
    fetchCreatorsInstagramSuccess(state, action) {
      const { creatorsLogs, pagination, statusMeta } = action.payload;
      state.creatorsInstagramInfo.loading = false;
      state.creatorsInstagramInfo.creatorsLogs = creatorsLogs;
      state.creatorsInstagramInfo.pagination = pagination;
      state.creatorsInstagramInfo.statusMeta = statusMeta;
    },
    fetchCreatorsInstagramFailure(state, action) {
      state.creatorsInstagramInfo.loading = false;
      state.creatorsInstagramInfo.error = action.payload;
    },
    verifyCreatorRequest(state, action) {
      state.verifyInfo.loading = true;
      state.verifyInfo.error = null;
      state.verifyInfo.creatorUserId = action.payload.creator_user_id;
      state.verifyInfo.success = "";
    },
    verifyCreatorSuccess(state, action) {
      state.verifyInfo.loading = false;
      state.verifyInfo.success = true;

      const updateStatus = state.creatorsInstagramInfo.creatorsLogs;
      const index = updateStatus.findIndex(
        (log) => log.creator_user_id === state.verifyInfo.creatorUserId
      );
      if (index !== -1) {
        // remobe that creator log
        updateStatus.splice(index, 1);
        state.creatorsInstagramInfo.creatorsLogs = [...updateStatus];
      }

      // update statusMeta counts
      if (state.creatorsInstagramInfo.statusMeta) {
        const { completed, pending } = state.creatorsInstagramInfo.statusMeta;
        state.creatorsInstagramInfo.statusMeta.completed = completed + 1;
        state.creatorsInstagramInfo.statusMeta.pending = pending - 1;
      }
    },
    verifyCreatorFailure(state, action) {
      state.verifyInfo.loading = false;
      state.verifyInfo.error = action.payload;
      state.verifyInfo.success = true;
    }
  }
});

export const useCreatorsVerificationSlice = () => {
  useInjectReducer(
    CreatorsVerificationSlice.name,
    CreatorsVerificationSlice.reducer
  );
  useInjectSaga(CreatorsVerificationSlice.name, creatorsVerificationSaga);
  const actions = useMemo(() => CreatorsVerificationSlice.actions, []);
  return { actions };
};

export const { actions: creatorsVerificationActions } =
  CreatorsVerificationSlice;
export default CreatorsVerificationSlice.reducer;
